/**
 * cortex-admin の pipeline_permissions API contract（zod schema + 型）。
 *
 * @graph-stack cortex-admin
 * @graph-domain Infrastructure
 * @graph-business pipeline_permissions/default の取得 / 保存 API ↔ Web 型を共有し、権限ドキュメントの二重定義を排除する。
 * @graph-connects none
 */
import { z } from 'zod';
/** pipeline_permissions に保存できる Google Workspace user id。 @graph-connects none */
export const PipelinePrincipalSchema = z
    .string()
    .regex(/^\d{20,22}$/, 'Google Workspace user id（20〜22 桁の数字列）で指定してください。slackId / email 等は使えません');
/** pipeline feature ID。 @graph-connects none */
export const PipelineFeatureIdSchema = z.enum([
    'database',
    'mongodb',
    'jobcan',
    'spreadsheet',
    'drive',
]);
/** pipeline 種別ごとの operator マップ。 @graph-connects none */
export const FeatureOperatorsSchema = z.object({
    database: z.array(PipelinePrincipalSchema).optional(),
    mongodb: z.array(PipelinePrincipalSchema).optional(),
    jobcan: z.array(PipelinePrincipalSchema).optional(),
    spreadsheet: z.array(PipelinePrincipalSchema).optional(),
    drive: z.array(PipelinePrincipalSchema).optional(),
});
/** targetDb ごとの operator マップ。 @graph-connects none */
export const TargetDbOperatorsSchema = z.record(z.string().min(1), z.array(PipelinePrincipalSchema));
/** pipeline_permissions レスポンス。 @graph-connects none */
export const PipelinePermissionsSchema = z.object({
    admins: z.array(PipelinePrincipalSchema),
    featureOperators: FeatureOperatorsSchema,
    targetDbOperators: TargetDbOperatorsSchema.optional(),
    updatedBy: z.string(),
    createdAt: z.string().optional(),
    updatedAt: z.string().optional(),
});
/** pipeline_permissions 保存リクエスト。 @graph-connects none */
export const SavePipelinePermissionsRequestSchema = z.object({
    admins: z.array(PipelinePrincipalSchema).min(1, 'admins は最低 1 件必要です'),
    featureOperators: FeatureOperatorsSchema,
    targetDbOperators: TargetDbOperatorsSchema.optional(),
});
//# sourceMappingURL=permissions.js.map